import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import vision from "../../../assets/images/feature/mission.png";
import shape from "../../../assets/images/feature/shape.png";
import { Link } from "react-router-dom";

const MisionSection = () => {
  const [cmsData, setCmsData] = useState([]);
  const [status, setStatus] = useState(null);
  const [imagePath, setimagePath] = useState([]);
  const [fooder, setfooder] = useState("");

  useEffect(() => {
    fetchCMSData();
   footerdata()
  }, []);

  const fetchCMSData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/cmslist`);
      setCmsData(res.data.data); // Save entire list
      setStatus(res.data.status);
      setimagePath(res.data.imagePath);
    } catch (error) {
      console.error("Error fetching CMS data", error);
    }
  };
  const footerdata = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/site-setting`
      );
      setfooder(res.data.data);
      // setstatus(res.data.status);
    } catch (error) {}
  };
  // Filter items by type
  const aboutUsItems = cmsData.filter((item) => item.type === "mission");
  return (
    <>
      {fooder.missionpermission == 1 ? (
        <section className="py-60 mission">
          <Container>
            {aboutUsItems.map((item, index) => (
              <Row className="align-items-center">
                <Col lg={6}>
                  <div className="pe-md-5 sec-title">
                    <h6 className="color-primary mb-8">–––– Mission</h6>
                    <h2 className="title mb-4">
                      {/* Our <br />
                  <strong>commitment to</strong> <br />
                  <strong>diversity leadership.</strong> */}
                      {item.name}
                    </h2>
                    <p
                      className="mb-4"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></p>
                    {/* <Link to="/About-us" className="educate-btn">
                      <span className="educate-btn__curve"></span> Get Started
                    </Link> */}
                  </div>
                </Col>
                <Col lg={6} className="mb-4 mb-lg-0">
                  <div className="position-relative">
                    <img
                      src={item?.image ? `${imagePath}${item.image}` : vision}
                      alt="mision"
                      className="mision_img img-fluid rounded"
                    />
                    <img
                      src={shape}
                      alt="Decorative Shape"
                      className="position-absolute bottom-0 end-0"
                    />
                  </div>
                </Col>
              </Row>
            ))}
          </Container>
        </section>
      ) : (
        ""
      )}
    </>
  );
};

export default MisionSection;
